// extracted by mini-css-extract-plugin
export default {"root":"AiChatLoader_root__07LNV","spinning":"AiChatLoader_spinning__2R0O7","ai-chat-loader-spin":"AiChatLoader_ai-chat-loader-spin__oqexD"};